import {recordRumError} from '../../util/datadog/datadogRum';

/**
 * wandb.Videos can be webm, mp4, or gifs
 */
export enum VideoMimeType {
  Webm = 'video/webm',
  Mp4 = 'video/mp4',
}

enum GifMimeType {
  Gif = 'image/gif',
}

type MimeType =
  | {type: 'video'; mimeType: VideoMimeType}
  | {type: 'gif'; mimeType: GifMimeType};

export function videoMimeTypeFromFilename(filename?: string): MimeType {
  if (!filename) {
    recordRumError('video-mime-type-from-filename-missing-filename');
    return {type: 'video', mimeType: VideoMimeType.Mp4};
  }
  return mimeFromPath(filename.toLowerCase());
}

function mimeFromPath(filename: string): MimeType {
  if (filename.endsWith('.webm')) {
    return {type: 'video', mimeType: VideoMimeType.Webm};
  }
  if (filename.endsWith('.mp4')) {
    return {type: 'video', mimeType: VideoMimeType.Mp4};
  }
  if (filename.endsWith('.gif')) {
    return {type: 'gif', mimeType: GifMimeType.Gif};
  }
  recordRumError('video-mime-type-from-filename-unknown-extension', {
    filename,
  });
  return {type: 'video', mimeType: VideoMimeType.Mp4};
}
